import ajax from './index'
import apiEnv from './apiEnv'
// B2B
// B2B工单列表
export function getJobB2BList(data) {
    return ajax.post(`${apiEnv.api4}/api/B2bJob/GetJobList`, data)
}
// 工单详情
export function getJobDetails(data) {
    return ajax.post(`${apiEnv.api4}/api/B2bJob/GetJobDetails`, data)
}
// 提交编辑工单详情
export function updateJobInfo(data) {
    return ajax.post(`${apiEnv.api4}/api/B2bJob/UpdateJobInfo`, data)
}
// 审核工单
export function auditJob(data) {
    return ajax.post(`${apiEnv.api4}/api/B2bJob/AuditJob`, data)
}
// 获取双方信息
export function jobCompanyInfo(data) {
    return ajax.post(`${apiEnv.api4}/api/B2bJob/JobCompanyInfo`, data)
}
// 获取匹配资源池
export function jobApplyOrderList(data) {
    return ajax.post(`${apiEnv.api4}/api/B2bJob/JobApplyOrderList`, data)
}
// 获取匹配资源池详情
export function jobApplyOrderInfo(data) {
    return ajax.post(`${apiEnv.api4}/api/B2bJob/JobApplyOrderInfo`, data)
}
// 资源池-设为中标人
export function chooseReceiver(data) {
    return ajax.post(`${apiEnv.api4}/api/B2bJob/ChooseReceiver`, data)
}
// 资源池-排除投标
export function removeApplyOrder(data) {
    return ajax.post(`${apiEnv.api4}/api/B2bJob/RemoveApplyOrder`, data)
}
// b2b项目工单的服务节点
export function jobReportList(data) {
    return ajax.post(`${apiEnv.api4}/api/B2bJob/JobReportList`, data)
}
// 获取b2b项目工单的财务结算
export function getJobReportInfo(data) {
    return ajax.post(`${apiEnv.api4}/api/JobServiceReport/GetJobReportInfo`, data)
}
// 提交b2b项目工单的财务结算
export function authJobReport(data) {
    return ajax.post(`${apiEnv.api4}/api/JobServiceReport/AuthJobReport`, data)
}
// 获取b2b项目工单的合同
export function getJobContract(data) {
    return ajax.post(`${apiEnv.api4}/api/B2bJob/GetJobContract`, data)
}
// 保存b2b项目工单合同
export function updateJobContract(data) {
    return ajax.post(`${apiEnv.api4}/api/B2bJob/UpdateJobContract`, data)
}
// 确认开票获取开票信息 b2b项目工单
export function applyProjectInvoiceData(data) {
    return ajax.post(`${apiEnv.api4}/api/Receivable/ApplyProjectInvoiceData`, data)
}
// 确认开票 b2b项目工单
export function confirmProjectInvoice(data) {
    return ajax.post(`${apiEnv.api4}/api/Receivable/ConfirmProjectInvoice`, data)
}
// 确认支付 b2b项目工单
export function projectAppLyInvoiceByManage(data) {
    return ajax.post(`${apiEnv.api4}/api/Receivable/ProjectAppLyInvoiceByManage`, data)
}






// 自由
// 自由工单列表
export function getJobFreeList(data) {
    return ajax.post(`${apiEnv.api4}/api/FreeJob/GetJobList`, data)
}
// 急单费用退款
export function urgentAmountRefund(data) {
    return ajax.post(`${apiEnv.api4}/api/FreeJob/UrgentAmountRefund`, data)
}


// 获取工单费用明细（财务结算 -> 自由、b2b标准）
export function getJobAmountInfo(data) {
    return ajax.post(`${apiEnv.api4}/api/B2bJob/GetJobAmountInfo`, data)
}
// 获取服务进度（自由、B2B标准）
export function jobProgress(data) {
    return ajax.post(`${apiEnv.api4}/api/B2bJob/JobProgress`, data)
}
// 获取服务进度详情（自由、B2B标准）
export function jobProgressDetail(data) {
    return ajax.post(`${apiEnv.api4}/api/B2bJob/JobProgressDetail`, data)
}
// 获取服务报告工程师（自由、B2B标准）
export function getJobReportUser(data) {
    return ajax.post(`${apiEnv.api4}/api/JobServiceReport/GetJobReportUser`, data)
}
// 获取服务报告（自由、B2B标准）
export function getJobServiceReport(data) {
    return ajax.post(`${apiEnv.api4}/api/JobServiceReport/GetJobServiceReport`, data)
}
// 获取 总费用 优惠券
export function getAfterDiscountsTrueTotalAmount(data) {
    return ajax.post(`${apiEnv.api4}/api/JobServiceReport/GetAfterDiscountsTrueTotalAmount`, data)
}
// 添加服务日志
export function addJobWorkLog(data) {
    return ajax.post(`${apiEnv.api1}/JobWorkflow/PickJobCenter/AddJobWorkLog`, data)
}
// 获取某一天服务日志
export function getEngineerDayWorkLog(data) {
    return ajax.post(`${apiEnv.api1}/JobWorkflow/PickJobCenter/GetEngineerDayWorkLog`, data)
}
// 删除某一个服务日志
export function removeJobWorkLog(data) {
    return ajax.post(`${apiEnv.api1}/JobWorkflow/PickJobCenter/RemoveJobWorkLog`, data)
}
// 修改某一个服务日志
export function updateEngineerDayWorkLog(data) {
    return ajax.post(`${apiEnv.api1}/JobWorkflow/PickJobCenter/UpdateEngineerDayWorkLog`, data)
}

// 保存个人工程师服务报告
export function saveJobEngineerReport(data) {
    return ajax.post(`${apiEnv.api4}/api/JobServiceReport/SaveJobEngineerReport`, data)
}
// 全部提交服务报告
export function saveJobServiceReport(data) {
    return ajax.post(`${apiEnv.api4}/api/JobServiceReport/SaveJobServiceReport`, data)
}
// 速派评价
export function saveSuPaiEvaluate(data) {
    return ajax.post(`${apiEnv.api4}/api/JobServiceReport/SaveSuPaiEvaluate`, data)
}
// 拒绝审核 拒绝服务报告/验收报告
export function refuseJobReport(data) {
    return ajax.post(`${apiEnv.api4}/api/JobServiceReport/RefuseJobReport`, data)
}
// 获取工单评价信息
export function getJobEvaluate(data) {
    return ajax.post(`${apiEnv.api4}/api/JobServiceReport/GetJobEvaluate`, data)
}



// 工单列表分类
export function getJobStepList(data) {
    return ajax.post(`${apiEnv.api4}/api/B2bJob/GetJobStepList`, data)
}
// 获取工单状态
export function getJobStatusList(data) {
    return ajax.post(`${apiEnv.api4}/api/B2bJob/GetJobStatusList`, data)
}
// 获取负责人
export function getTakeOverUserList(data) {
    return ajax.post(`${apiEnv.api4}/api/B2bJob/GetTakeOverUserList`, data)
}
 
//修改工单的负责人
export function updateJobAdminUser(data) {
    return ajax.post(`${apiEnv.api4}/api/B2bJob/UpdateJobAdminUser`, data)
}
// 获取行业
export function getDropDownIndustryList(data) {
    return ajax.post(`${apiEnv.api1}/api/Code/GetDropDownIndustryList`, data)
}


// 新增 || 编辑 领域（产品线）
export function saveJobProductLine(data) {
    return ajax.post(`${apiEnv.api4}/api/B2bJob/SaveJobProductLine`, data)
}
// 删除 领域（产品线）
export function deleteJobProductLine(data) {
    return ajax.post(`${apiEnv.api4}/api/B2bJob/DeleteJobProductLine`, data)
}
// 获取领域
export function getproductDomains(data) {
    return ajax.post(`${apiEnv.api1}/api/Code/ProductDomains`, data)
}
// 获取产品 || 品牌 || 系列
export function getProductBrands(data) {
    return ajax.post(`${apiEnv.api1}/api/Code/ProductBrands`, data)
}
// 服务类型
export function getServiceStages(data) {
    return ajax.post(`${apiEnv.api1}/api/Code/ServiceStagesByDomain`, data)
}
// 推荐工程师列表
export function getEngineerList(data) {
    return ajax.post(`${apiEnv.api4}/api/JobRecommend/GetEngineerList`, data)
}
// 推荐服务站列表
export function getCompanyList(data) {
    return ajax.post(`${apiEnv.api4}/api/JobRecommend/GetCompanyList`, data)
}
// 工程师简历 || 服务站简历
export function getBasicInfo(data) {
    return ajax.post(`${apiEnv.api2}/gz/app/resume/info/basicInfo`, data)
}
// 推荐 项目工单 获取费用节点
export function getJobAmountNoteList(data) {
    return ajax.post(`${apiEnv.api4}/api/JobRecommend/GetJobAmountNoteList`, data)
}
// 推荐 项目工单 费用节点修改/添加
export function saveJobAmountNote(data) {
    return ajax.post(`${apiEnv.api4}/api/JobRecommend/SaveJobAmountNote`, data)
}
// 推荐 项目工单 费用节点删除/删除所有
export function deleteJobAmountNote(data) {
    return ajax.post(`${apiEnv.api4}/api/JobRecommend/DeleteJobAmountNote`, data)
}
// 推荐 
export function jobRecommend(data) {
    return ajax.post(`${apiEnv.api4}/api/JobRecommend/JobRecommend`, data)
}
// 三方通话
export function axbBindPhone(data) {
    return ajax.post(`${apiEnv.api1}/api/BpoPrivateNumber/AxbBindPhone`, data)
}







// 获取工单取消、释放原因
export function operationReason(data) {
    return ajax.post(`${apiEnv.api1}/JobWorkflow/PickJob/GetOperationReason`, data)
}
// 释放工单(自由、b2b标准)
export function releaseJob(data) {
    return ajax.post(`${apiEnv.api4}/api/B2bJob/ReleaseJob`, data)
}
// 关闭工单
export function closeJob(data) {
    return ajax.post(`${apiEnv.api4}/api/B2bJob/CloseJob`, data)
}
// 获取工单价格配置
export function jobPriceConfig(data) {
    return ajax.post(`${apiEnv.api4}/api/B2bJob/GetJobPriceConfig`, data)
}
// 更新工单价格配置信息
export function updateJobDispose(data) {
    return ajax.post(`${apiEnv.api4}/api/B2bJob/UpdateJobDispose`, data)
}
// 添加备注
export function addRemark(data) {
    return ajax.post(`${apiEnv.api4}/api/B2bJob/AddRemark`, data)
}
// 获取备注列表
export function remarkList(data) {
    return ajax.post(`${apiEnv.api4}/api/B2bJob/GetRemarkList`, data)
}

// 生成小程序二维码
export function wxBase64(data) {
    return ajax.post(`${apiEnv.api2}/gz/app/wx/miniqr/base64`, data)
}

// 获取工单税率
export function getJobTax(data) {
    return ajax.post(`${apiEnv.api4}/api/JobRecommend/GetJobTax`, data)
}

// B2B保存工程师的服务报告
export function saveProjectJobEngineerReport(data) {
    return ajax.post(`${apiEnv.api4}/api/JobServiceReport/SaveProjectJobEngineerReport`, data)
}


// v4.4
// 获取工单的服务价格配置
export function GetJobConfigurationPrice(data) {
    return ajax.post(`${apiEnv.api4}/api/B2bJob/GetJobConfigurationPrice`, data)
}
// 保存工单服务报价
export function SaveJobConfigurationPrice(data) {
    return ajax.post(`${apiEnv.api4}/api/B2bJob/SaveJobConfigurationPrice`, data)
}

// 获取用户的服务能力内容
export function getEngineerServiceAbilityContent(data) {
    return ajax.post(`${apiEnv.api4}/api/BpoUserEngineer/GetEngineerServiceAbilityContent`, data)
}

// 提交服务能力内容
export function updateEngineerServiceAbilityContent(data) {
    return ajax.post(`${apiEnv.api4}/api/BpoUserEngineer/UpdateEngineerServiceAbilityContent`, data)
}

// 提交拒单内容
export function jobRefuse(data) {
    return ajax.post(`${apiEnv.api4}/api/JobRecommend/JobRefuse`, data)
}

// 获取拒单列表
export function getRefuseJobList(data) {
    return ajax.post(`${apiEnv.api4}/api/JobRecommend/GetRefuseJobList`, data)
}
// 获取投诉列表
export function getUserComplaintList(data) {
    return ajax.post(`${apiEnv.api4}/api/JobRecommend/GetUserComplaintList`, data)
}

// 获取接单列表
export function getPickJobList(data) {
    return ajax.post(`${apiEnv.api1}/JobWorkflow/PickJobCenter/GetMyPickJobList`, data)
}
// 修改工单的服务报告文件
export function updateJobFile(data) {
    return ajax.post(`${apiEnv.api4}/api/JobServiceReport/UpdateJobFile`, data)
}
// 修改项目工单的验收报告文件
export function updateJobReportFile(data) {
    return ajax.post(`${apiEnv.api4}/api/B2bJob/UpdateJobReportFile`, data)
}
 // 修改工单标签
export function setJobTag(data) {
    return ajax.post(`${apiEnv.api4}/api/B2bJob/SetJobTag`, data)
}
 // 工单挂起
 export function jobHangUp(data) {
    return ajax.post(`${apiEnv.api4}/api/B2bJob/JobHangUp`, data)
}
 // 工单报价
 export function jobQuotedPrice(data) {
    return ajax.post(`${apiEnv.api4}/api/B2bJob/JobQuotedPrice`, data)
}
 // 切换工单外呼
 export function UpdateJobMatch(data) {
    return ajax.post(`${apiEnv.api4}/api/B2bJob/UpdateJobMatch`, data)
}
 // 修改扩展信息
 export function updateJobExtendInfo(data) {
    return ajax.post(`${apiEnv.api4}/api/B2bJob/UpdateJobExtendInfo`, data)
}

 
 // 获取标准单子报价
 export function getJobQuotedPriceList(data) {
    return ajax.post(`${apiEnv.api4}/api/B2bJob/GetJobQuotedPriceList`, data)
}
//获取IP所在城市
export function getLocationCity(params) {
    return ajax.post('http://api.map.baidu.com/location/ip?ak=ia6HfFL660Bvh43exmH9LrI6')
}
//城市列表
export function GetSelectCityView(params) {
    return ajax.post(`${apiEnv.api1}/api/Account/AccountAddress/GetSelectCityView`, params)
}
//高德key
export function GetGaodeKey(params) {
    return ajax.post(`${apiEnv.api1}/api/NewBpoConfig/GetGaodeMapKey`, params)
}

//上游报价
export function JobUpOffer(params) {
    return ajax.post(`${apiEnv.api4}/api/JobPriceAudit/JobUpOffer`, params)
}
//下游报价
export function JobDownOffer(params) {
    return ajax.post(`${apiEnv.api4}/api/JobPriceAudit/JobDownOffer`, params)
}
//获取工单客户的速派销售
export function GetJobSupaiSalePerson(params) {
   
    return ajax.post(`${apiEnv.api4}/api/B2bJob/GetJobSupaiSalePerson`, params)
}

//获取工单费用，税率信息
export function GetJobRateInfo(params) {
    return ajax.post(`${apiEnv.api4}/api/JobPriceAudit/GetJobRateInfo`, params)
}
//获取工单报价列表
export function GetJobOfferPrice(params) {
    return ajax.post(`${apiEnv.api4}/api/JobPriceAudit/GetJobOfferPrice`, params)
}
//暂停 打开报价
export function SwitchJobOffer(params) {
    return ajax.post(`${apiEnv.api4}/api/JobPriceAudit/SwitchJobOffer`, params)
}
//审核工单报价
export function AuditJobOffer(params) {
    return ajax.post(`${apiEnv.api4}/api/JobPriceAudit/AuditJobOffer`, params)
}

//获取工单现场信息
export function GetJobSiteInfo(params) {
    return ajax.post(`${apiEnv.api4}/api/B2bJob/GetJobSiteInfo`, params)
}
 
//获取工单报价的利润率
export function GetJobOfferRate(params) {
    return ajax.post(`${apiEnv.api4}/api/JobPriceAudit/GetJobOfferRate`, params)
}
 
//获取用户资源统计
export function getUserStatictice(params) {
    return ajax.post(`${apiEnv.api4}/api/JobRecommend/GetUserStatictice`, params)
}
 

//获取配置
export function getConfigList(params) {
    return ajax.post(`${apiEnv.api4}/api/DistributeJob/GetConfigList`, params)
}
 
//保存配置
export function saveConfig(params) {
    return ajax.post(`${apiEnv.api4}/api/DistributeJob/SaveConfig`, params)
}
 

//修改配置状态
export function updateActivateStatus(params) {
    return ajax.post(`${apiEnv.api4}/api/DistributeJob/UpdateActivateStatus`, params)
}
 

//获取值班列表
export function getDistributeJobHolidayDayList(params) {
    return ajax.post(`${apiEnv.api4}/api/DistributeJob/GetDistributeJobHolidayDayList`, params)
}
 
//添加值班
export function addDistributeJobHolidayDay(params) {
    return ajax.post(`${apiEnv.api4}/api/DistributeJob/AddDistributeJobHolidayDay`, params)
}
  
//移除值班
export function removeDistributeJobHolidayDay(params) {
    return ajax.post(`${apiEnv.api4}/api/DistributeJob/RemoveDistributeJobHolidayDay`, params)
}
